import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/homepage";
import SolutionsGallery from './pages/solutions-gallery';
import IndustryApplications from './pages/industry-applications';
import ImplementationHub from './pages/implementation-hub';
import PartnerEcosystem from './pages/partner-ecosystem';
import TechnologyPlatform from './pages/technology-platform';
import Homepage from './pages/homepage';

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/solutions-gallery" element={<SolutionsGallery />} />
        <Route path="/industry-applications" element={<IndustryApplications />} />
        <Route path="/implementation-hub" element={<ImplementationHub />} />
        <Route path="/partner-ecosystem" element={<PartnerEcosystem />} />
        <Route path="/technology-platform" element={<TechnologyPlatform />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
